import { cn } from '@risksmart-app/atomic-ui';
import { getColorStyles } from '@risksmart-app/components/src/utils/colours';
import type { ResolvedRating } from 'src/ratings/useRiskRatingResolver';

interface RatingBadgeProps {
  rating: ResolvedRating | undefined;
  notRatedLabel: string;
  className?: string;
  testId?: string;
}

const RatingBadge = ({
  rating,
  notRatedLabel,
  className,
  testId,
}: RatingBadgeProps) => {
  if (!rating) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-sm whitespace-nowrap bg-muted text-muted-foreground',
          className
        )}
        data-testid={testId}
      >
        {notRatedLabel}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm whitespace-nowrap',
        className
      )}
      style={getColorStyles(rating.color)}
      data-testid={testId}
    >
      {`${rating.label} (${rating.value})`}
    </span>
  );
};

export { RatingBadge };
